import { useMemo } from "react";

import {
  addDays,
  endOfMonth,
  endOfWeek,
  startOfMonth,
  startOfWeek,
} from "date-fns";

import { CalendarSettings } from "../types";

export const usePaddedMonth = (
  date: Date,
  { weekStartsOn }: CalendarSettings
): Date[] => {
  const paddedMonth = useMemo(() => {
    const start = startOfWeek(startOfMonth(date), { weekStartsOn }); // Monday as the starting day
    const end = endOfWeek(endOfMonth(date), { weekStartsOn });

    const days = [];
    let currentDay = start;

    while (currentDay <= end) {
      days.push(currentDay);
      currentDay = addDays(currentDay, 1);
    }

    return days;
  }, [date, weekStartsOn]);

  return paddedMonth;
};
